import { BOOKING_TYPE } from "@/constants/booking-type";

export const convertBookingTypeToName = (type: number): string => {
  switch (type) {
    case BOOKING_TYPE.SHARED_SPACE:
      return "Espaço Compartilhado";
    case BOOKING_TYPE.MEETING_ROOM:
      return "Sala de Reunião";
    case BOOKING_TYPE.EVENT_SPACE:
      return "Espaço de Evento";
    case BOOKING_TYPE.PRIVATE_OFFICE_CROSS_PRODUCT:
      return "Escritório Privativo";
    case BOOKING_TYPE.EXTRA_SERVICE:
      return "Serviço Extra";
    default:
      return "Desconhecido";
  }
};
